fragment OrgConfigForTenantFragment on OrgConfigForTenant {
  id
  config {
    branding {
      appName
      logoImage {
        src
        alt
        styles
      }
      gradients
      stockImagesDisabled
    }
    announcements {
      mapperNotification {
        message
        colour
        isActive
        visualTreatment
      }
      directoryNotification {
        message
        colour
        isActive
        visualTreatment
      }
    }
    featureFlags {
      enableWorkspaceSwitcher
      individualContactOptions {
        phone
        email
        microsoftTeams
      }
      designs {
        enableDesigns
        enableDesignProvisioning
      }
      enableGlobalSearch
      enableAiFeatures
    }
    aiCustomisations {
      abbreviationsRaw
    }
    locale
    currencySymbol
  }
  createdAt
  createdBy
}

fragment OrgConfigForWorkspaceFragment on OrgConfigForWorkspace {
  id
  config {
    branding {
      appName
      logoImage {
        src
        alt
        styles
      }
      gradients
    }
  }
  createdAt
  createdBy
}

query getOrgConfigForTenant {
  config: getOrgConfigForTenant {
    ...OrgConfigForTenantFragment
  }
}

query getOrgConfigForWorkspace {
  config: getOrgConfigForWorkspace {
    ...OrgConfigForWorkspaceFragment
  }
}

mutation updateOrgConfigForTenant($input: OrgConfigForTenantInput!) {
  config: updateOrgConfigForTenant(input: $input) {
    ...OrgConfigForTenantFragment
  }
}

mutation updateOrgConfigForWorkspace($input: OrgConfigForWorkspaceInput!) {
  config: updateOrgConfigForWorkspace(input: $input) {
    ...OrgConfigForWorkspaceFragment
  }
}
